/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */
'use strict';
module.exports = {
    0: 'covid',
    1: 'freebies',
    2: 'roomServices',
    3: 'hotelServices',
    4: 'wellness',
    5: 'foodPlace',
    6: 'technology',
    7: 'transport',
    8: 'sports',
    9: 'entertainment',
    10: 'general',
    11: 'facilities',
    12: 'childrenServices',
    13: 'business',
};
